import {
  ERichModalFileNormStatus,
  ERichModalFileParseStatus,
  EFileSelectErr,
} from "./types";
import i18next from "../../i18n";
export const FILE_SIZE_UNIT = 1024 * 1024;

export const SUPPORTED_IMAGE_TYPE = [
  "png",
  "jpg",
  "jpeg",
  "webp",
  // "apng",
  // "avif",
  // "gif",
  // "svg",
  // "webp",
];

export const MOE_SUPPORTED_FILE_TYPE = [...SUPPORTED_IMAGE_TYPE, "xls", "xlsx"];

export const MAX_UPLOAD_FILE_SIZE = 30 * FILE_SIZE_UNIT;
export const MAX_UPLOAD_FILE_SIZE_FOR_DEMO = 30 * FILE_SIZE_UNIT;

export const MAX_UPLOAD_FILE_NUMBER = 50;
export const MAX_UPLOAD_IMAGE_NUMBER = 4;

export const MAX_IMAGE_PX = 13000;

export const MIN_IMAGE_PX = 224;

export const UPLOAD_FILE_ACCEPT =
  ".pdf, .doc, .docx, .ppt, .pptx, .txt, .md, .epub, .mobi";

/**************************** 通用对话 ****************************/
// 文件格式
export const CHAT_SUPPORTED_FILE_TYPE = ["pdf", "txt", "doc", "docx"];
// 文件数量
export const CHAT_MAX_UPLOAD_FILE_NUMBER = 1;
// 文件大小，单位MB
export const CHAT_MAX_UPLOAD_FILE_SIZE = 2;
/**************************** 通用对话 ****************************/

// nova文件上传url
const NOVA_FILE_UPLOAD_URL_MAP = {
  "stage": "https://file.stage.sensenova.cn/v1/files",
  "production": "https://file.sensenova.cn/v1/files",
};
export const NOVA_FILE_UPLOAD_URL = NOVA_FILE_UPLOAD_URL_MAP[NOVA_ENV];
// export const NOVA_FILE_UPLOAD_URL = "https://file.stage.sensenova.cn/v1/files";
// export const NOVA_FILE_UPLOAD_URL = "https://file.sensenova.cn/v1/files";

// nova状态文案
export const FILE_STATUS_TEXT: any = {
  [ERichModalFileNormStatus.error]: "抱歉, 上传失败", // "抱歉, 上传解析失败",
  [ERichModalFileNormStatus.netError]: i18next.t("sensechat-139"), // "网络异常，请恢复网络后重试",
  [ERichModalFileNormStatus.parsing]: i18next.t("sensechat-140"), // "努力解析中……",
  [ERichModalFileNormStatus.uploading]: i18next.t("sensechat-141"), // "上传中……",
  [ERichModalFileNormStatus.formatError]: "暂不支持该文件格式", // "上传中……",
  // [ERichModalFileParseStatus.success]: "解析成功", // "解析成功",
  [ERichModalFileNormStatus.noWords]: "没有解析出文字", // "没有解析出文字",
  [ERichModalFileParseStatus.failed]: "未能完成解析, 请换个图片/文档试试", // "解析失败，请稍后重试",
  [ERichModalFileParseStatus.invalid]: "该文档不符合平台规范，不宜上传", // "解析失败，请稍后重试",
  [ERichModalFileParseStatus.timeout]:
    "文档过大或复杂，处理超时，请简化文档后重试",
  [ERichModalFileParseStatus.empty]: "文件为空，请上传有效文档",
  [ERichModalFileParseStatus.limit429]: "太火爆了",
  [ERichModalFileNormStatus.longParsing]: i18next.t("sensechat-147"), // "内容复杂，努力解析中……",
};

// 长文本最多上传文件数量
export const LONG_TEXT_FILE_MAX_COUNT = 10;

// 长文本上传文件最大值,单位m
export const LONG_TEXT_FILE_MAX_SIZE = 10;

// 文件选择错误提示
export const FILE_SELECT_ERR = {
  [EFileSelectErr.Error]: i18next.t("sensechat-148"), // "服务异常，请稍后重试",
  [EFileSelectErr.IllegalFileEncoding]: i18next.t("sensechat-149"), // "目前仅支持UTF-8编码的文档，请转换编码再试",
  [EFileSelectErr.IllegalFileFormat]: i18next.t("sensechat-150"), // "该文件格式暂不支持，请转换格式再试",
  [EFileSelectErr.OverNumber]: i18next.t("sensechat-151", {
    sum: LONG_TEXT_FILE_MAX_COUNT,
  }), // `最多上传{{sum}}个文件`,
  [EFileSelectErr.OverSize]: i18next.t("sensechat-152", {
    size: LONG_TEXT_FILE_MAX_SIZE,
  }), // "每个文件不能超过{{size}}MB",
};
